import { parseArray, parseBoolean } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'
import { RolodexEntryJson } from './rolodexEntryFields'

/**
 * A feature flag to enable DuckDB in Forecast, with both whitelists and blacklists
 */
export class DuckDbFeatureFlag extends GeckoEntryBase<{
  enabled: Readonly<boolean>
  whiteList: ReadonlySet<string>
  blackList: ReadonlySet<string>
}> {
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        enabled: parseBoolean(json.data.enabled) ?? false,
        whiteList: new Set(parseArray<string>(json.data.white_list)),
        blackList: new Set(parseArray<string>(json.data.black_list)),
      },
      {},
      {}
    )
  }

  public isEntryEnabled(entry: RolodexEntryJson) {
    const taggedEntries = Object.values(entry.tags)
    for (const tag of taggedEntries) {
      if (tag && this.data.blackList.has(tag)) {
        return false
      }
    }
    for (const tag of taggedEntries) {
      if (tag && this.data.whiteList.has(tag)) {
        return true
      }
    }
    return this.data.enabled
  }

  /**
   * A simple factory method which creates DuckDbFeatureFlag from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new DuckDbFeatureFlag(json)
  }

  public static CreateDefault() {
    const json = {
      id: 'default-feature-flag',
      type: 'forecast-duckdb-feature-flag',
      data: {
        enabled: false,
        white_list: [],
        black_list: [],
      },
      tags: {},
      index: {},
      generation: 1,
      updated_at: new Date(Date.now()).toISOString(),
      view_restriction: null,
    }
    return new DuckDbFeatureFlag(json as RolodexEntryJson)
  }
}
